import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/irr-calculator',
  component: () => import('../../routes/IrrCalculator.svelte'),
  card: {
    id: 'irr-calculator',
    title: 'IRR Calculator',
    description: 'Calculate the Internal Rate of Return (IRR) for an investment with irregular cash flows over time.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/irr-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'IRR Calculator – Internal Rate of Return Calculator',
    description: 'Free IRR calculator to compute the internal rate of return for investments with irregular cash flows. Analyze profitability and compare investment opportunities.',
  },
};

export default meta;
